import { FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { Send } from 'react-feather'

import { CustomTimeline, CustomLoading } from '../../../../../common'

export const ObservationLog = ({ useFetchInit }) => {

    const {
        FetchData,
        Actions,
        Forms
    } = useFetchInit

    const { fetchAllObservations } = FetchData
    const { dataObservations, loadingFetchObservations } = fetchAllObservations

    const { onSubmitObservationsForm } = Actions

    const { ObservationsForm } = Forms
    const { formState, onInputChange } = ObservationsForm

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Comentarios
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 2 }}>
                {(loadingFetchObservations)&&(<CustomLoading/>)}
                <CustomTimeline
                    observations={dataObservations}
                />
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="log_observacion">Comentarios</label>

                        <TextField
                            id='log_observacion'
                            name='log_observacion'
                            value={ formState.log_observacion } 
                            onChange={onInputChange}
                            size='small'
                            placeholder=''
                            type='text'
                            multiline
                            rows={4}
                            variant='outlined'
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="send message"
                                            onClick={onSubmitObservationsForm}
                                        >
                                            <Send />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>
                </Grid> 
            </Grid>
        </>
    )
}
